import Vue from 'vue';
import vueGiantSigner from '@/components/plugins/giant-signer/index';

Vue.use(vueGiantSigner);
